module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content displayJob"
  }, [_c('div', {
    ref: "exportBigQuryPopup",
    staticClass: "exportBigQuryPopupWrapper"
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modelpopContainer exportBigQuryPopup"
  }, [_c('a', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        return _vm.closeexportBigQuryPopup()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "exportBqCheckbox clearfix"
  }, [_c('div', {
    staticClass: "expotbgjobname"
  }, [_vm._v("Job Name: " + _vm._s(_vm.currentExportName))]), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.bgQcheckerrormsg))]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "id": "selall",
      "value": "123",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.selectallbqtype ? 'checked' : ''
    },
    on: {
      "change": function($event) {
        return _vm.exporttypeBqselctedAll()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "selall"
    }
  }, [_vm._v("Select All")])]), _vm._v(" "), _vm._l((_vm.exporttypeBq), function(exporttypeBq) {
    return _c('div', {
      key: exporttypeBq.id,
      ref: "exportbgCompo",
      refInFor: true,
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exporttypeBq.checked),
        expression: "exporttypeBq.checked"
      }],
      ref: exporttypeBq.ref,
      refInFor: true,
      attrs: {
        "type": "checkbox",
        "id": exporttypeBq.ref
      },
      domProps: {
        "checked": exporttypeBq.checked,
        "value": exporttypeBq.id,
        "checked": Array.isArray(exporttypeBq.checked) ? _vm._i(exporttypeBq.checked, exporttypeBq.id) > -1 : (exporttypeBq.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = exporttypeBq.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = exporttypeBq.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(exporttypeBq, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(exporttypeBq, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(exporttypeBq, "checked", $$c)
          }
        }, function($event) {
          return _vm.exporttypeBqselcted(exporttypeBq.id, exporttypeBq.checked)
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": exporttypeBq.ref
      }
    }, [_vm._v(_vm._s(exporttypeBq.name))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "btnexporttobigqwrapper"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-large",
    attrs: {
      "rel": "btnexporttobigq"
    },
    on: {
      "click": function($event) {
        return _vm.exporttobigqClick()
      }
    }
  }, [_vm._v("Export")])])])])])]), _vm._v(" "), _c('div', {
    ref: "shareamodel",
    staticClass: "ShareModelPopupWrapper"
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modelpopContainer exportBigQuryPopup"
  }, [_c('a', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        return _vm.closeShareModel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "exportBqCheckbox clearfix"
  }, [_c('div', {
    staticClass: "sharejobid"
  }, [_vm._v("Job ID: " + _vm._s(_vm.currentShareJob))]), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.bgQcheckerrormsg))]), _vm._v(" "), _c('div', {
    staticClass: "shareselectbtn"
  }, [_c('button', {
    ref: "selallforshare",
    staticClass: "btn btn-primary btn-small",
    attrs: {
      "value": "all"
    },
    on: {
      "click": function($event) {
        return _vm.shareAllusers(_vm.shareselectAll)
      }
    }
  }, [_vm._v(_vm._s(_vm.shareselecttxt))])]), _vm._v(" "), _vm._l((_vm.shareJob), function(shareJob, index) {
    return (shareJob.user_id !== _vm.currentuser) ? _c('div', {
      key: shareJob.user_id,
      ref: "sharejobref",
      refInFor: true,
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedshareJobType),
        expression: "selectedshareJobType"
      }],
      attrs: {
        "type": "checkbox",
        "id": shareJob.user_id
      },
      domProps: {
        "checked": shareJob.shared === 1 ? 'checked' : '',
        "value": shareJob.user_id,
        "checked": Array.isArray(_vm.selectedshareJobType) ? _vm._i(_vm.selectedshareJobType, shareJob.user_id) > -1 : (_vm.selectedshareJobType)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedshareJobType,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = shareJob.user_id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedshareJobType = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedshareJobType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedshareJobType = $$c
          }
        }, function($event) {
          return _vm.selectedshareJob(index, _vm.selectedshareJobType)
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": shareJob.user_id
      }
    }, [_vm._v(_vm._s(shareJob.fullname))])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "btnexporttobigqwrapper"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-large",
    attrs: {
      "rel": "ShareJobClick"
    },
    on: {
      "click": function($event) {
        return _vm.ShareJobClick()
      }
    }
  }, [_vm._v("Share")])])])])])]), _vm._v(" "), _c('Createjob', {
    ref: "jobcompo",
    attrs: {
      "showmodelprop": _vm.showmodelin,
      "copymodel": _vm.CopyModelBool,
      "copyData": _vm.CopiedData
    }
  }, [_vm._v("Test")]), _vm._v(" "), _c('vue-good-table', {
    ref: "jobtable",
    attrs: {
      "selectOptions": _vm.selectionOptions,
      "mode": "local",
      "isLoading": _vm.isLoadingcompo,
      "styleClass": "table table-bordered condensed",
      "columns": _vm.columns,
      "rows": _vm.RowFilter,
      "paginate": true,
      "lineNumbers": true,
      "perPage": 22,
      "sortable": true,
      "globalSearch": false,
      "name": "test",
      "sort-options": {
        enabled: false
      }
    },
    on: {
      "on-row-click": _vm.onPageChange,
      "on-select-all": _vm.onPageChangeSelectALL,
      "on-selected-rows-change": _vm.selectionChanged,
      "on-cell-click": _vm.onCellClick,
      "on-sort-change": _vm.onSortChange
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_c('div', {
          staticClass: "td-wrapper"
        }, [(props.column.field == 'name') ? _c('div', {
          staticClass: "viewrepottbuttonwrapper"
        }, [_c('a', {
          staticClass: "viewmodellink",
          attrs: {
            "href": "javascript:"
          },
          on: {
            "click": function($event) {
              return _vm.viewreportbuttonClick(props.row)
            }
          }
        }, [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]) : _vm._e(), _vm._v(" "), (props.column.field == 'name') ? _c('div', {
          staticClass: "settingswrapper"
        }, [_c('button', {
          staticClass: "btn btn-primary view-btn settingsBtn",
          attrs: {
            "tabindex": "-1",
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.openSetting(props, props.row, $event)
            }
          }
        }, [_c('svg', {
          attrs: {
            "width": "20",
            "height": "20",
            "viewBox": "0 -3 35 35",
            "fill": "#ffffff"
          }
        }, [_c('g', {
          attrs: {
            "transform": "scale(0.03125 0.03125)"
          }
        }, [_c('path', {
          attrs: {
            "d": "M933.79 610.25c-53.726-93.054-21.416-212.304 72.152-266.488l-100.626-174.292c-28.75 16.854-62.176 26.518-97.846 26.518-107.536 0-194.708-87.746-194.708-195.99h-201.258c0.266 33.41-8.074 67.282-25.958 98.252-53.724 93.056-173.156 124.702-266.862 70.758l-100.624 174.292c28.97 16.472 54.050 40.588 71.886 71.478 53.638 92.908 21.512 211.92-71.708 266.224l100.626 174.292c28.65-16.696 61.916-26.254 97.4-26.254 107.196 0 194.144 87.192 194.7 194.958h201.254c-0.086-33.074 8.272-66.57 25.966-97.218 53.636-92.906 172.776-124.594 266.414-71.012l100.626-174.29c-28.78-16.466-53.692-40.498-71.434-71.228zM512 719.332c-114.508 0-207.336-92.824-207.336-207.334 0-114.508 92.826-207.334 207.336-207.334 114.508 0 207.332 92.826 207.332 207.334-0.002 114.51-92.824 207.334-207.332 207.334z"
          }
        })])])]), _vm._v(" "), _c('div', {
          ref: "settingPopup",
          staticClass: "settingPopup"
        }, [_c('a', {
          staticClass: "closebtn",
          on: {
            "click": function($event) {
              return _vm.settingPopupClose(props, props.row, $event)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times",
          attrs: {
            "aria-hidden": "true"
          }
        })]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-sm btn-primary view-btn settingsBtn btnShareJob",
          on: {
            "click": function($event) {
              return _vm.CopyModel(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-files-o"
        })]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-sm settingsDel btn-primary view-btn settingsBtn btn-red",
          attrs: {
            "tabindex": "-1",
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.removeSelectedJobAlert(props.row, $event)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })]), _vm._v(" "), _c('button', {
          staticClass: "btn btnbigquerry btn-sm",
          on: {
            "click": function($event) {
              _vm.openexportbgPopuop(props.row)
            }
          }
        }), _vm._v(" "), _c('button', {
          staticClass: "btn btn-sm btn-primary view-btn settingsBtn btnShareJob",
          on: {
            "click": function($event) {
              _vm.openShareJobPopuop(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-share-alt"
        })])])]) : _vm._e(), _vm._v(" "), (props.column.field == 'status') ? _c('div', {
          staticClass: "statusLoader"
        }, [(props.formattedRow[props.column.field] === 'created') ? _c('i', {
          staticClass: "fa fa-check-circle yellow",
          attrs: {
            "aria-hidden": "true"
          }
        }) : _vm._e(), _vm._v(" "), (props.formattedRow[props.column.field] === 'completed') ? _c('i', {
          staticClass: "fa fa-check-circle green",
          attrs: {
            "aria-hidden": "true"
          }
        }) : _vm._e(), _vm._v(" "), (props.formattedRow[props.column.field] === 'in-progress') ? _c('i', {
          staticClass: "fa fa-spinner green",
          attrs: {
            "aria-hidden": "true"
          }
        }) : _vm._e(), _vm._v(" "), (props.formattedRow[props.column.field] === 'failed') ? _c('i', {
          staticClass: "fa fa-exclamation-circle red",
          attrs: {
            "aria-hidden": "true"
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "statusLoaderover"
        }, [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]) : (props.column.field !== 'name') ? _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))]) : _vm._e()])]
      }
    }])
  }, [_c('template', {
    slot: "loadingContent"
  }, [_c('span', {
    staticClass: "vgt-loading__content"
  }, [_c('div', {
    staticClass: "dataspinner"
  }, [_c('span', [_vm._v("Loading Data")]), _vm._v(" "), _c('div', {
    staticClass: "bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3"
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "selected-row-actions"
    },
    slot: "selected-row-actions"
  }, [_c('button', {
    staticClass: "btn btn-large btn-primary btn-red deleteAllbtn",
    on: {
      "click": function($event) {
        return _vm.removeMultiSelectedJobAlert()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-btnbigquerry",
    on: {
      "click": function($event) {
        return _vm.exportMultiSelectedJobAlert()
      }
    }
  }, [_c('i', {
    staticClass: "btnbigquerry btnbigquerry-over"
  })])])], 2)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "stepsheading expotbgheading"
  }, [_vm._v("Export to Bigquery")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "stepsheading expotbgheading"
  }, [_vm._v("Share a Model")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cceac4ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Displayjob.vue
// module id = 1011
// module chunks = 1